import useSWR from "swr";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getCategoryBySlug } from "../../Service/CategoryService";

export const useCategoryBySlug = ({ categorySlug }) => {

    const hasAccess = useApiAccess();

    return useSWR(
        hasAccess ? `${apiRoutes.categoryBySlug}${categorySlug}` : null,
        () => getCategoryBySlug({ categorySlug })
    );
}